import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
// import MaterialList from './materials'
// import InstanceTest from './instanceTest'
// import ModelList from './integration/productList'
import ModelDetail from './integration/productPage'
// import { DeployVerify } from './integration/deployVerify'
import './styles.css'
import ModelSearch from './integration/productSearch'

createRoot(document.getElementById('root')).render(
  <Router>
    <Routes>
      <Route path="/" element={<ModelSearch />} />
      <Route path="/model/:modelId" element={<ModelDetail />} />
    </Routes>
  </Router>,
)

// doc ready
var dom_is_ready = (callback) => {
  if (document.readyState !== 'loading') {
    callback()
  } else {
    document.addEventListener('DOMContentLoaded', callback)
  }
}

dom_is_ready(() => {
  if (typeof window !== 'undefined') {
    if (typeof window.PUPPETEER_DATA !== 'undefined') {
      document.body.classList.add('puppeteer-page')
    }
  }
})
